import { color } from '@starryui10/theme/color';
import React from 'react';

export const Search = () => {
    return (
        <svg role="presentation" fill="none" xmlns="http://www.w3.org/2000/svg" height="96px" width="96px" viewBox="0 0 96 96">
            <circle cx="48" cy="48" r="48" fill={color.Grey.G10} />
            <g filter="url(#searchGraphic_document)">
                <path
                    d="M28.7937 69H55.6999C56.6918 69 57.4936 68.246 57.4936 67.3245V38.841L48.5249 30.4635H28.7937C27.8018 30.4635 27 31.2175 27 32.139V67.3245C27 68.246 27.8018 69 28.7937 69Z"
                    fill={color.Blue.B20}
                    stroke={color.Blue.B60}
                    strokeWidth="2"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M32.4863 64.5345H44.0978" stroke={color.Blue.B60} strokeWidth="2" strokeLinecap="round" />
                <path d="M32.4863 58.2828H52.8064" stroke={color.Blue.B60} strokeWidth="2" strokeLinecap="round" />
                <path d="M32.4863 52.031H52.8064" stroke={color.Blue.B60} strokeWidth="2" strokeLinecap="round" />
            </g>
            <g filter="url(#searchGraphic_magnifier)">
                <path
                    d="M66.8878 38.9439C66.8878 47.7485 59.7485 54.8879 50.9439 54.8879C42.1393 54.8879 34.9999 47.7485 34.9999 38.9439C34.9999 30.1393 42.1393 23 50.9439 23C59.7485 23 66.8878 30.1393 66.8878 38.9439Z"
                    fill="white"
                    stroke={color.Blue.B60}
                    strokeWidth="2"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M73.572 65.3277L66.0607 57.8165C65.0155 56.7712 65.0155 55.0882 66.0607 54.0607C67.0882 53.0155 68.7712 53.0155 69.8164 54.0607L77.3277 61.572C78.3729 62.6172 78.3729 64.3002 77.3277 65.3277C76.3002 66.3729 74.6172 66.3729 73.572 65.3277Z"
                    fill="white"
                    stroke={color.Blue.B60}
                    strokeWidth="2"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M66.1671 54.1674L62.6052 50.6054"
                    stroke={color.Blue.B60}
                    strokeWidth="2"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <filter
                    id="searchGraphic_document"
                    x="21"
                    y="26.4635"
                    width="42.4936"
                    height="50.5365"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
                    <feOffset dy="2" />
                    <feGaussianBlur stdDeviation="2.5" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0.152941 0 0 0 0 0.156863 0 0 0 0 0.2 0 0 0 0.2 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
                </filter>
                <filter
                    id="searchGraphic_magnifier"
                    x="28.9999"
                    y="19"
                    width="55.1117"
                    height="55.1116"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
                    <feOffset dy="2" />
                    <feGaussianBlur stdDeviation="2.5" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0.152941 0 0 0 0 0.156863 0 0 0 0 0.2 0 0 0 0.2 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
                </filter>
            </defs>
        </svg>
    );
};
